import { P2 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const List = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 24px;
  grid-row-gap: 12px;

  ${QUERIES.tabletAndUp} {
    grid-template-columns: 1fr 1fr;
  }

  ${QUERIES.largeTabletAndUp} {
    grid-template-columns: 1fr 1fr 1fr;
  }

  ${QUERIES.laptopAndUp} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;

export const StyledLink = styled(P2).attrs(() => ({ as: 'a' }))`
  color: ${themeStyle.varInkMedium};
  border: 1px solid ${themeStyle.varInkLight};
  background: ${themeStyle.varBackgroundAlt};
  cursor: pointer;
  border-radius: ${themeStyle.radiusMedium};
  padding: 7px 14px;
  text-transform: capitalize;

  transition:
    box-shadow 0.3s,
    color 0.3s,
    font-weight 0.3s;
  &:hover {
    box-shadow: ${themeStyle.varShadowSmallFocus};
    font-weight: ${themeStyle.fontSemiBold};
    color: ${themeStyle.varInkMain};
  }
`;
